import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { BlockPicker } from "react-color";
import { getTokens } from "../../styles/tokens";
import { usePanelStyles, ModalTitle } from "../FormFields/panel";

const ColorPicker = ({ onChange, currentColor, handleClose, open }) => {
  const p = usePanelStyles();
  const theme = useTheme();
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  const [selectedColor, setSelectedColor] = useState(currentColor);

  const handleChange = (color) => {
    setSelectedColor(color.hex);
    onChange(color.hex);
  };

  // O seletor do react-color traz cartão branco e sombra próprios: aqui ele herda a superfície do modal.
  const pickerStyles = {
    default: {
      card: { width: "100%", background: "transparent", boxShadow: "none", borderRadius: t.radius.sm },
      head: { height: 72, borderRadius: t.radius.sm },
      body: { padding: "14px 0 0" },
      input: {
        width: "100%",
        height: 36,
        padding: "0 10px",
        fontSize: 13,
        fontFamily: t.font,
        color: t.text,
        background: t.paper,
        border: `1px solid ${t.inputBorder}`,
        borderRadius: t.radius.sm,
        boxShadow: "none",
        boxSizing: "border-box",
      },
    },
  };

  const colors = [
    "#B80000",
    "#DB3E00",
    "#FCCB00",
    "#008B02",
    "#006B76",
    "#1273DE",
    "#004DCF",
    "#5300EB",
    "#EB9694",
    "#FAD0C3",
    "#FEF3BD",
    "#C1E1C5",
    "#BEDADC",
    "#C4DEF6",
    "#BED3F3",
    "#D4C4FB",
    "#4D4D4D",
    "#999999",
    "#F44E3B",
    "#FE9200",
    "#FCDC00",
    "#DBDF00",
    "#A4DD00",
    "#68CCCA",
    "#73D8FF",
    "#AEA1FF",
    "#FDA1FF",
    "#333333",
    "#808080",
    "#cccccc",
    "#D33115",
    "#E27300",
    "#FCC400",
    "#B0BC00",
    "#68BC00",
    "#16A5A5",
    "#009CE0",
    "#7B64FF",
    "#FA28FF",
    "#666666",
    "#B3B3B3",
    "#9F0500",
    "#C45100",
    "#FB9E00",
    "#808900",
    "#194D33",
    "#0C797D",
    "#0062B1",
    "#653294",
    "#AB149E",
  ];

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="color-picker-title"
      open={open}
      maxWidth="xs"
      fullWidth
      classes={{ paper: p.dialogPaper }}
    >
      <ModalTitle id="color-picker-title" title="Escolher cor" onClose={handleClose} />
      <DialogContent className={p.modalBody}>
        <BlockPicker
          width={"100%"}
          triangle="hide"
          color={selectedColor}
          colors={colors}
          styles={pickerStyles}
          onChange={handleChange}
          onChangeComplete={color => onChange(color.hex)}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClose}>
          Concluir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorPicker;
